<template lang="pug">
div
  .pop-message(v-if="popMessage")
    img.pop-cancel(src='/images/cancel-icon.png' @click="toggleMessage(0)")
    img.pop-image(v-if="$helpers.timingControl('2025-11-01 00:00')" src="/images/pop11.png" @click="openUrl")
    img.pop-image(v-else src="/images/pop9.png" @click="openUrl")
  template(v-if="isLoggedIn")
    review
    reviewComplete
    #modal-4anni.modal.fade(tabindex='-1' aria-hidden='true')
      .modal-dialog.modal-dialog-centered.modal-fullscreen
        .ci-cmsg-wrapper
          .ci-cmsgbox
            .bbg
              img(src='/images/nov/pop.png')
            .ccon
              .ttext Please contact our Livechat to claim your MYR 40 Angpao
              .bclose(data-bs-dismiss='modal' aria-label='Close' @click="openChat") CONFIRM
              //- .ttext The MYR 2025 winners will be announced on 01 January 2025
  //- #tac.modal.fade(tabindex='-1' aria-hidden='true' v-if="!isLoggedIn")
    .modal-dialog.modal-dialog-centered
      .modal-content
        img.pointer(src='/images/tac.png' @click="openChat")
  .t-header
    section.mob-top.ep-mobtop(v-if="showMobile")
      .mob-ind
        router-link(to="/")
          i.fa-solid.fa-angles-left
      div.text-capitalize {{getDisplayWord()}}
    section.header-top(v-if="!showMobile")
      .header-container
        .logo
          router-link(to="/")
            img(src='/images/logo.png')
        .header-right
          .af-header(v-if="isLoggedIn")
            .circle
              router-link(to="/profile")
                img(src='/images/menu/m-profile.png')
            .af-user
              router-link(to="/profile")
                | {{ $t('ui.hi') }} {{ getDisplayName }}
                template(v-if="$store.getters.username")
                  br
                  | ({{$store.getters.accountID}})
            div
              .af-bal {{$t('ui.current_balance')}}
              .baltext
                span.myr-num.pointer(@click="$router.push('/deposit').catch(err => {})") RM {{$numeral(currentBalance).format("0,0.00")}}
                a.reload-mw(href="javascript:void(0)" @click="getBalance")
                  i.fa-solid.fa-rotate-right
            div(v-if="$helpers.timingControl('2025-04-16 00:00', '2025-07-31 23:59')")
              .af-bal Epic Lucky Smash Token:
              .baltext.justify-content-end(style="color:yellow")
                span.myr-num.pointer(@click="$router.push('/event').catch(err => {})") {{spintokenBal}}
                a.reload-mw.reload-right(href="javascript:void(0)" @click="$router.push('/event').catch(err => {})")
                  i.fa-solid.fa-chevron-right
            .desktop-daily-checkin(
              v-if="$helpers.timingControl('2025-09-01 00:00', '2025-09-30 23:59')"
              style="height: 50px; width: 130px; background-image: url('/images/daily-check-in-for-desktop.png');background-size:cover;cursor:pointer"
              @click="$router.push('/missions').catch(err => {})"
            )
            .af-inbox.circle
              router-link(to="/inbox")
                span.dot.dot-blink(v-if="notification > 0") {{notification}}
                img(src='/images/menu/m-inbox.png')
            div
              router-link(to="/deposit")
                img(src='/images/deposit.gif')

          .hdrow
            template(v-if="!isLoggedIn")
              button.login-btn(type='button' @click="$router.push('/login').catch(err => {})") {{$t('ui.login')}}
              button.login-btn.reg(type='button' @click="$router.push('/register').catch(err => {})")
                p.animate__animated.animate__heartBeat.animate__infinite {{$t('ui.register')}}
            .event(v-if="$helpers.timingControl('2025-10-25 00:00', '2025-10-31 23:59')")
              //- span(style="color:yellow") 11.11 Angpow : {{ $store.getters.currencyCode }} {{$numeral(rayaAngpow * 0.5).format("0,0.00")}}
              .e-icon.mx-1
                a(@click="checkStatus")
                  img(src='/images/event/halloween.png')
              a(@click="checkStatus")
                .outer
                  .progress(role='progressbar' aria-label='progress bar' :aria-valuenow='depoProgress' aria-valuemin='0' aria-valuemax='100' v-if="isLoggedIn")
                    .progress-bar.progress-bar-striped.progress-bar-animated(:style="'width:'+depoProgress+'%'")
                      span RM{{$numeral(depoAmount).format("0,0.00")}} / RM{{$numeral(targetAmount).format("0,0.00")}} 
                  .progress(role='progressbar' aria-label='progress bar' aria-valuenow='0' aria-valuemin='0' aria-valuemax='100' v-if="!isLoggedIn")
                    .progress-bar.progress-bar-striped.progress-bar-animated(:style="'width:0%'")
                      span RM{{$numeral(0).format("0,0.00")}} / RM{{$numeral(1000).format("0,0.00")}} 
                //- .progress(role='progressbar' aria-label='progress bar' :aria-valuenow='depoProgress' aria-valuemin='0' aria-valuemax='100' v-if="isLoggedIn")
                //-   .progress-bar.progress-bar-striped.progress-bar-animated(:style="'width:'+depoProgress+'%'")
                //-     span RM{{$numeral(depoAmount).format("0,0.00")}} / RM{{$numeral(targetAmount).format("0,0.00")}} 
                //- .progress(role='progressbar' aria-label='progress bar' aria-valuenow='0' aria-valuemin='0' aria-valuemax='100' v-if="!isLoggedIn")
                  .progress-bar.progress-bar-striped.progress-bar-animated(:style="'width:0%'")
                    span RM{{$numeral(0).format("0,0.00")}} / RM{{$numeral(1000).format("0,0.00")}} 
            .download.ms-2.statement-mob(v-if="showPrompt && !isIOS" @click="triggerDownload")
              img(src='/images/download.png')
            .download.ms-2.statement-mob(v-if="isIOS && showTutorial" href='javascript:void(0)')
              img(src='/images/download.png' @click="openTutorial")
            .language-wrap
              .lang-c(data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
                button.language-btn(type='button')
                  img(:src="'/images/'+getLanguage+'.png'")
                i.fa-solid.fa-caret-down
              .dropdown-menu.language
                button.language-btn.dropitem(type='button' @click="setLanguage('en')")
                  img(src='/images/en.png')
                button.language-btn.dropitem(type='button' @click="setLanguage('zh')")
                  img(src='/images/zh.png')
                button.language-btn.dropitem(type='button' @click="setLanguage('my')")
                  img(src='/images/my.png')
            .af-header.ms-2.pointer(v-if="isLoggedIn" @click="logout")
              i.fa-solid.fa-arrow-right-from-bracket.fa-2xl
    // desktop menu
    section.header-btm
      .header-container
        ul.nav.top-menu
          li.nav-item(:class="{'active': currentPath ==='/slot'}")
            router-link.nav-link(to="/slot")
              img.topmenu-icon(src='/images/menu/c-slot.png')
              | {{$t('ui.slotgames')}}
          li.nav-item(:class="{'active': currentPath ==='/partners'}")
            router-link.nav-link(to="/partners")
              img.topmenu-icon(src='/images/menu/c-partner.png')
              | {{$t('ui.partner')}}
          li.nav-item(:class="{'active': currentPath ==='/live'}")
            router-link.nav-link(to="/live")
              img.topmenu-icon(src='/images/menu/c-live.png')
              | {{$t('ui.live')}}
          li.nav-item(:class="{'active': currentPath ==='/fish'}")
            router-link.nav-link(to="/fish")
              img.topmenu-icon(src='/images/menu/c-fish.png')
              | {{$t('ui.fish')}}
          li.nav-item(:class="{'active': currentPath ==='/poker'}")
            router-link.nav-link(to="/poker")
              img.topmenu-icon(src='/images/menu/c-poker.png')
              | {{$t('ui.poker')}}
          li.nav-item(:class="{'active': currentPath ==='/minigame'}")
            router-link.nav-link(to="/minigame")
              span.badge.bg-danger.dot-blink New
              img.topmenu-icon(src='/images/menu/c-game.png')
              | {{$t('ui.minigame')}}
          //- li.nav-item
            router-link.nav-link(to="/vip")
              img.topmenu-icon(src='/images/menu/c-vip.png')
              | VIP
          li.nav-item(:class="{'active': currentPath ==='/promotions'}")
            router-link.nav-link(to="/promotions")
              span.badge.bg-danger.dot-blink New
              img.topmenu-icon(src='/images/menu/c-bonus.png')
              | {{$tc('ui.bonus')}}
          li.nav-item(:class="{'active': currentPath ==='/reviews'}")
            router-link.nav-link(to="/reviews")
              img.topmenu-icon(src='/images/menu/c-rank.png')
              | {{$tc('ui.leaderboard')}}
          li.nav-item(:class="{'active': currentPath ==='/lottery'}")
            router-link.nav-link(to="/lottery")
              img.topmenu-icon(src='/images/menu/c-4d.png')
              | {{$t('ui.lottery')}}
          li.nav-item(:class="{'active': currentPath ==='/referral'}")
            router-link.nav-link(to="/referral")
              img.topmenu-icon(src='/images/menu/c-refer.png')
              | Referral
          li.nav-item(:class="{'active': currentPath ==='/freeplay'}")
            router-link.nav-link(to="/freeplay")
              img.topmenu-icon(src='/images/menu/c-free.png')
              | {{$t('ui.demoplay')}}
          li.nav-item(:class="{'active': currentPath ==='/news'}")
            router-link.nav-link(to="/news")
              img.topmenu-icon(src='/images/menu/c-blog.png')
              | {{$tc('ui.news')}}
  .t-body
    router-view
  footerInfo
  .float-icon.mb-1(v-if="currentPath === '/'")
    router-link(to="/event" v-if="$helpers.timingControl('2025-08-01 00:00')")
      img(v-if="$helpers.timingControl('2025-11-01 00:00')" src='/images/float11.gif')
      img(v-else src='/images/event.gif')
    a(href="https://t.me/epicgroupfree100" target="_blank")
      img(src='/images/telegram.png')
    a(href="https://epicwin8.net/winning-tips/" target="_blank")
      img(src='/images/winningtips.png')
    a(href='javascript:void(0)' @click="openChat")
      img(src='/images/livechat.png')
  .float-icon-left.mb-1(v-if="currentPath === '/' && showIcon")
    template(v-if="$helpers.timingControl('2025-05-16 12:00', '2025-06-17 23:59')")
      a(href="https://dolphinreef88.com/RF13386232" target="_blank")
        img(src='/images/float-dr.gif')
      .close-tutorial(@click="closeIcon")
        img(src='/images/cancel-icon.png')
    template(v-else)
      a(href="https://rm711slot.com/RF18065010" target="_blank")
        img(src='/images/711.gif')
      //- a(v-if="isLoggedIn"  href="javascript:void(0)" @click="toPromo(21)")
      //-   img(src='/images/float.gif')
      //- router-link(v-else  to="/register")
      //-   img(src='/images/float.gif')
      .close-tutorial(@click="closeIcon")
        img(src='/images/cancel-icon.png')
  //- .mob-evebanner
    .cclose.vv-close-evebanner
      img(src='/images/cancel-icon.png')
    a(v-if="showPrompt && !isIOS" href='javascript:void(0)' @click="triggerDownload")
      img(src='/images/download.png')
    a(v-if="isIOS && showTutorial" href='javascript:void(0)')
      img(src='/images/download.png' @click="openTutorial")
  section.btm-fixed-menu
    .menu-btm-wrapper
      router-link(:class="{'active' : currentPath==='/'}" to="/")
        .btm-icon
          img(src='/images/menu/m-home.png')
        div Home
      router-link(v-if="isLoggedIn" :class="{'active' : currentPath==='/statement'}" to="/statement")
        .btm-icon
          img(src='/images/menu/m-history.png')
        div {{$t('ui.statement')}}
      router-link(v-else to="/login")
        .btm-icon
          img(src='/images/menu/m-history.png')
        div {{$t('ui.statement')}}
      router-link(to="/promotions")
        .btm-icon.bonus
          img(src='/images/menu/m-bonus.gif')
        div
      template(v-if="isLoggedIn")
        router-link(:class="{'active' : currentPath==='/inbox'}" to="/inbox")
          span.dot.dot-blink(v-if="notification > 0") {{notification}}
          .btm-icon
            img(src='/images/menu/m-inbox.png')
          div {{$t('ui.inbox')}}
        router-link(:class="{'active' : currentPath==='/profile'}" to="/profile")
          .btm-icon
            img(src='/images/menu/m-profile.png')
          div {{$t('ui.profile')}}
      template(v-if="!isLoggedIn")
        router-link(to="/login")
          span.dot.dot-blink(v-if="notification > 0") {{notification}}
          .btm-icon
            img(src='/images/menu/m-inbox.png')
          div {{$t('ui.inbox')}}
        router-link(to="/login")
          .btm-icon
            img(src='/images/menu/m-profile.png')
          div {{$t('ui.profile')}}
  popupBanner
  tutorial
</template>
<script>
import footerInfo from '@/views/default/_footer.vue'
import review from "@/components2/_review.vue"
import reviewComplete from "@/components2/_reviewComplete.vue"
// import coupon from "@/components2/groupon/_grouponMain.vue"
import popupBanner from "@/components2/_popupBanner.vue"
import tutorial from "@/components2/_download.vue"
import { EventBus } from '@/store/event';
export default {
  components: {
    footerInfo,
    review,
    reviewComplete,
    // coupon,
    popupBanner,
    tutorial
  },
  data(){
    return{
      feedback:{
        success: true,
        status: ""
      },
      loading: false,
      currentPath: "",
      // showContent: true,
      showFooter: true,
      showMobile: false,
      showBanner: true,
      hideIcon:false,
      showPrompt: false,
      isIOS: false,
      showTutorial: false,
      depoAmount:"",
      targetAmount: 1000,
      depoProgress: "",
      showIcon: true,
      epwslot:[
        "https://epicwinslots.com/",
        "http://epicwinslots.com/",
        "https://www.epicwinslots.com/",
        "http://www.epicwinslots.com/"
      ],
      popMessage:false,
      messageOut: null
    }
  },
  computed:{
		isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    currentBalance() {
      return this.$store.getters.balance
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    notification(){
      if(this.isLoggedIn){
        return this.$store.state.user.inbox.length
      }else{
        return ""
      }
    },
    // rayaAngpow(){
    //   return this.$store.state.user.depositCount
    // },
    // spintokenBal(){
    //   return this.$store.state.user.spinToken
    // }
	},
  watch:{
    isLoggedIn(newState, oldState){
      if(newState){
        this.firstBalance()
        this.getMemberBankList()
        this.getInboxList()
        this.cnyDeposit()
        // this.dailyDepo()
        // this.rayaDeposit()
        if(this.$helpers.timingControl('2025-04-16 00:00', '2025-07-31 23:59')){
          this.getSpinToken()
        }
        
      }
    },
    $route (to, from){
      this.currentPath = to.path
      // this.showContent = this.$helpers.routeCheck(to.path)
      this.showFooter = this.$helpers.footerFilter(to.path)
      this.checkSize()
      // if(to.path === '/promotions' || to.path === '/inbox' || to.path === '/profile'){
      //   this.showContent = false
      // }else{
      //   this.showContent = true
      // }
    }
  },
  beforeMount(){
    this.getMobile()
    // this.checkSize()
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault()
      this.triggerEvent = e;
      this.showPrompt = true
    });
  },
  mounted() {
    this.loadGtag()
    this.loadSchema()
    this.loadMessage()
    this.currentPath = this.$router.currentRoute.path
    // this.showContent = this.$helpers.routeCheck(this.$router.currentRoute.path)
    this.showFooter = this.$helpers.footerFilter(this.$router.currentRoute.path)
    AOS.init({
      once: true,disable: 'mobile'
    });
    this.checkSize()
    var vm = this
    $(window).resize(function () {
      vm.checkPop()
      vm.checkSize()
    });
    if (this.$store.getters.isLoggedIn) {
      this.getBalance()
      this.getInboxList()
      // this.rayaDeposit()
      if(this.$helpers.timingControl('2025-04-16 00:00', '2025-07-31 23:59')){
        this.getSpinToken()
      }
    }
    this.refreshBalance = setInterval(() => {
      if (this.$store.getters.isLoggedIn) {
        this.getBalance()
        // this.rayaDeposit()
        // this.getInboxList()
        if(this.$helpers.timingControl('2025-04-16 00:00', '2025-07-31 23:59')){
          this.getSpinToken()
        }
      }
    }, 8000)
    this.checkAnn()
    this.cnyDeposit()
    // this.dailyDepo()
  },
  beforeDestroy: function() {
    clearInterval(this.refreshBalance)
    // clearInterval(this.refreshInbox)
    // clearInterval(this.continueRefreshInbox)
  },
  methods: {
    toPromo(target){
      this.$router.push("/promotions").catch(error =>{}).finally(() => {
        this.$nextTick(() => {
          EventBus.$emit('custom', target);
        });
      });
    },
    openUrl(){
      window.open("https://t.me/epicwininfinity", "_blank")
      this.popMessage = false
    },
    toggleMessage(option){
      if(option == 1){
        this.popMessage = true
        setTimeout(() => this.toggleMessage(0), 5000);
      }else{
        this.popMessage = false
      }
    }, 
    loadMessage(){
      if(this.$helpers.timingControl('2025-11-01 00:00') === false){
        return
      }
      if (this.isMobile()) {
        this.messageOut = setTimeout(() => {
          this.toggleMessage(1) // Clears the timeout before it executes
        }, 10000);
      }
    },
    checkPop(){
      if (this.isMobile()) {

      }else{
        this.popMessage = false
        clearTimeout(this.messageOut)
      }
    },
    isMobile(){
      var userAgentIsMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      var screenIsSmall = window.innerWidth <= 768;
      return userAgentIsMobile || screenIsSmall;
    },
    loadGtag(){
      var site = window.location.protocol + "//" + window.location.hostname + "/";
      if(this.epwslot.includes(site)){
        if (!document.querySelector('script[src="https://www.googletagmanager.com/gtag/js?id=G-4RBY9KY5WX"]')) {
          // Create a script element
          const script = document.createElement('script');
          script.src = 'https://www.googletagmanager.com/gtag/js?id=G-4RBY9KY5WX';
          script.async = true;
          document.head.appendChild(script);

          // Initialize gtag after the script is loaded
          script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            function gtag() {
              window.dataLayer.push(arguments);
            }
            gtag('js', new Date());
            gtag('config', 'G-4RBY9KY5WX'); // Replace with your Measurement ID
          };
        }
      }
    },
    loadSchema(){
      var site = window.location.protocol + "//" + window.location.hostname + "/";
      if(this.epwslot.includes(site)){
        const schema = {
          "@context": "http://schema.org",
          "@type": "WebSite",
          "name": "EpicWin Slots",
          "url": "https://www.epicwinslots.com",
          "description": "EpicWin Slots offers a wide range of exciting online casino games and a great user experience.",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.epicwinslots.com/?s={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(schema);
        document.head.appendChild(script);
      }
      
    },
    closeIcon(){
      this.showIcon = false
    },
    checkStatus(){
      if(this.isLoggedIn){
        // $('#modal-4anni').modal("show");return;
        if(this.depoAmount >= 1000){
          $('#modal-4anni').modal("show")
        }else{
          this.$router.push('/promotions').catch(err => {})
        }
      }else{
        this.$router.push('/promotions').catch(err => {})
      }
      // this.$helpers.redirect('euro2024')
    },
    cnyDeposit(){ /* accumulate */
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/cnyDeposit", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                this.depoAmount = response.data[0].deposit_amount
                this.targetAmount = response.data[0].target_amount
                this.depoProgress = parseFloat(response.data[0].deposit_amount) / parseFloat(response.data[0].target_amount) * 100
                if(this.depoProgress > 100){
                  this.depoProgress = 100
                }
              }else{
                this.targetAmount = 1000
              }
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    rayaDeposit(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/rayaDeposit", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data.length > 0){
                // this.rayaAngpow = response.data[0].deposit_count
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    dailyDepo(){ /* daily */
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberStatement", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.depoAmount = response.data[0].deposit_amount
              this.depoProgress = parseFloat(response.data[0].deposit_amount) / 188 * 100
              if(this.depoProgress > 100){
                this.depoProgress = 100
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          })
      }
    },
    getSpinToken(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getSpinToken", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    checkAnn(){
      this.$store
        .dispatch("user/getAnnBanner")
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            if(response.annBeforeLog === true){
              if(!this.isLoggedIn){
                $("#annModal").modal("show");
              }
            }
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
    toInbox(){
      this.$router.push({
        name:"profile",
        params:{
          "inbox": true
        }
      }).catch(error =>{})
    },
    getInboxList(){
      if(this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.loading = true
        this.$store
          .dispatch("user/getInbox", { account_id, auth_token })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
            } else {
              this.feedback.status = this.$t("error." + response.status)
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.feedback.status = this.$t("error." + response.status)
          });
      }
    },
    setLanguage(payload) {
      this.$store.dispatch("user/setLanguage", payload)
    },
    firstBalance(){
      var vm = this
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              
            } else {
              if((typeof response.status) != 'object'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  confirmButtonText: "OK",
                  text: vm.$t("message.list." + response.status),
                  type: "info"
                }).then(result => {
                  this.$store
                    .dispatch("user/logout")
                    .catch(err => {})
                });
                
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getBalance() {
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              clearInterval(this.refreshBalance)
              this.$swal({
                title: vm.$tc("ui.attention"),
                confirmButtonText: "OK",
                text: vm.$t("message.list." + response.status),
                type: "info"
              }).then(result => {
                this.$store
                  .dispatch("user/logout")
                  .catch(err => {})
              });
            }
            if(response?.status?.status == 0){
              console.log('Network Error')
            }
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getMemberBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberBankList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getMobile() {
      let isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
      }

      if (isMobile.iOS()) {
        this.isIOS = true
        this.showTutorial = true
      } else {
        this.isIOS = false
        this.showTutorial = false
      }
    },
    hideTutorial(){
      this.showTutorial = false
    },
    openTutorial(){
      $("#modal-tutorial").modal("show")
    },
    triggerDownload(){
      this.triggerEvent.prompt();
      //user response
      this.triggerEvent.userChoice.then((response) => {
        if (response.outcome === 'accepted') {
          this.showPrompt = false
        } else {
          
        }
      });
    },
    toggleIcon(){
      this.hideIcon = !this.hideIcon
    },
    openChat(){
      LiveChatWidget.call("maximize");
    },
    hideBanner(){
      this.showBanner = false
    },
    openModal(target){
      $(target).modal("show")
    },
    checkSize(){
      if ($(window).width() < 900) {
        if(this.currentPath !== '' && this.currentPath !=='/'){
          this.showMobile = true
        }else{
          this.showMobile = false
        }
        
      }else{
        this.showMobile = false
      }
    },
    getDisplayWord(){
      switch(this.$router.currentRoute.path){
        case "/login":
          return this.$t('ui.login')
        case "/register":
          return this.$t('ui.register')
        case "/referral":
          return this.$t('ui.referral')
        case "/profile":
          return this.$t('ui.profile')
        case "/deposit":
          return this.$t('ui.deposit')
        case "/withdrawal":
          return this.$t('ui.withdrawal')
        case "/statement":
          return this.$t('ui.statement')
        case "/inbox":
          return this.$t('ui.inbox')
        case "/contactUs":
          return this.$t('ui.follow_us')
        case "/promotions":
          return this.$t('ui.bonus')
        case "/aboutUs":
          return this.$t('ui.aboutus')
        case "/faq":
          return this.$t('ui.faq')
        case "/tnc":
          return this.$t('ui.tnc')
        case "/missions":
          return this.$t('ui.dailycheckin')
        case "/euro2024":
          return "Euro 2024"
        case "/reset-password":
          return this.$t('ui.reset_password')
        case "/slot":
          return this.$t('ui.slots')
        case "/live":
          return this.$t('ui.live')
        case "/lottery":
          return this.$t('ui.lottery')
        case "/responsible-gaming":
          return this.$t('ui.responsible')
        default:
          var temp = window.location.pathname.split("/")
          var display = temp[temp.length-1].replace(/-/g," ")
          return display
      }
    },
    logout() {
      this.$store
        .dispatch("user/logout")
        .catch(err => {})
    },
  }
}
</script>
<style lang="scss" scoped>
.custom-height{
  @media(max-width: 767px){
    height: auto;
  }
}
</style>
